import React, { Component } from 'react'
import { Form, Input, Button, message, Select, DatePicker } from 'antd'
import { gql, compose, withApollo } from 'react-apollo'
import { withRouter } from 'react-router'

import { loginUser, registerUser } from '../../auth'

const FormItem = Form.Item
const Option = Select.Option
const currentUser = gql`
  query currentUser {
    currentUser {
      _id
      email
      profile {
        firstName
        lastName
        birthDate
        gender
      }
    }
  }
`
// function hasErrors (fieldsError) {
//   return Object.keys(fieldsError).some(field => fieldsError[field])
// }

class RegisterForm extends Component {
  state = {
    signupLoading: false
  }

  handleSignUp = e => {
    e.preventDefault()
    const { validateFields } = this.props.form
    this.setState({
      signupLoading: true
    })
    validateFields((err, values) => {
      // console.log('values', values)
      if (err) {
        console.error(err)
        this.setState({
          signupLoading: false
        })
        return
      }
      registerUser(values).then(res => {
        if (res.error) {
          this.setState({
            signupLoading: false
          })
          return message.error(res.error.message, 10)
        }
        loginUser(values).then(res => {
          if (res.error) {
            this.setState({
              loginLoading: false
            })
            return message.error(res.error.message, 10)
          }
          // console.log('login response', res)
          this.props.client
            .query({
              query: currentUser,
              fetchPolicy: 'network-only'
            })
            .then(data => {
              this.setState(
                {
                  loginLoading: false,
                  signupLoading: false
                },
                this.props.onClose
              )
              // console.log('state', this.props.location.state)
              const { from } = this.props.location.state || {
                from: { path: '/dashboard' }
              }
              this.props.history.push(from)
              this.props.form.resetFields()
            })
        })
      })
        // TODO: display toast
    })
  }

  checkPassword = (rule, value, callback) => {
    // const form = this.props.form
    if (value.length > 7) {
      callback()
    } else {
      callback('Your password too short!')
    }
  }

  render () {
    const {
      getFieldDecorator,
      // getFieldsError,
      // getFieldError,
      // isFieldTouched,
      // isFieldsTouched
    } = this.props.form
    return (
      <Form onSubmit={this.handleSignUp}>
        <div className="lineLoginTitle">
          <span className="loginModalTitle">OR</span>
        </div>
        <div className="loginTextField">
          <FormItem hasFeedback>
            {getFieldDecorator('profile.firstName', {
              rules: [
                {
                  required: true,
                  message: 'Please input your first name!'
                },
                {
                  message: 'Please input your first name!'
                }
              ]
            })(<Input placeholder="First Name" />)}
          </FormItem>
        </div>
        <div className="loginTextField">
          <FormItem hasFeedback>
            {getFieldDecorator('profile.lastName', {
              rules: [
                {
                  required: true,
                  message: 'Please input your last name!'
                },
                {
                  message: 'Please input your last name!'
                }
              ]
            })(<Input placeholder="Last Name" />)}
          </FormItem>
        </div>
        <div className="loginTextField">
          <FormItem hasFeedback>
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!'
                },
                {
                  required: true,
                  message: 'Please input your E-mail!'
                }
              ]
            })(<Input placeholder="Email" />)}
          </FormItem>
        </div>
        <div className="loginTextField">
          <FormItem hasFeedback>
            {getFieldDecorator('password', {
              rules: [
                {
                  required: true,
                  message: 'Please enter your password!'
                },
                {
                  validator: this.checkPassword
                }
              ]
            })(
              <Input
                type="password"
                placeholder="Password"
                onBlur={this.handleConfirmBlur}
              />
            )}
          </FormItem>
        </div>
        <div style={{ display: 'flex' }}>
          <div style={{ width: '50%' }}>
            <FormItem hasFeedback>
              {getFieldDecorator('profile.gender', {
                rules: [
                  { required: true, message: 'Please select your gender!' }
                ],
                onChange: this.handleSelectChange
              })(
                <Select placeholder="Gender">
                  <Option value="male">male</Option>
                  <Option value="female">female</Option>
                </Select>
              )}
            </FormItem>
          </div>
          <div style={{ width: '50%' }}>
            <FormItem wrapperCol={{ span: 16, offset: 2 }} hasFeedback>
              {getFieldDecorator('profile.birthDate')(
                <DatePicker placeholder="Birthday" style={{ width: '200' }} />
              )}
            </FormItem>
          </div>
        </div>
        <div className="loginTextField">
          <FormItem>
            {getFieldDecorator('profile.nationality', {})(
              <Input placeholder="Nationality" />
            )}
          </FormItem>
        </div>
        <div className="loginTextField">
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={this.state.signupLoading}
            style={{ float: 'right' }}
            // disabled={
            //   hasErrors(getFieldsError()) || !isFieldsTouched(['email'])
            // }
          >
            Sign Up
          </Button>
        </div>
      </Form>
    )
  }
}
export default compose(
  Form.create(),
  withApollo,
  withRouter // TODO: should put router only inside auth wrapper
)(RegisterForm)



// WEBPACK FOOTER //
// ./src/common/AuthModal/RegisterForm.js